import React from 'react';
import { styles } from '@sdir/sds';
import { isMobile } from 'react-device-detect';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import messages from '../../../localization/localization';
import IsMobile from '../../../services/contexts/ResponsiveContext';
import ApiServiceProvider from './ApiServiceProvider';
import store from 'src/store';

const Providers: React.FC = ({ children }) => {
  const lang = 'no';
  return (
    <Provider store={store}>
      <IntlProvider locale={lang} messages={messages.no}>
        <ThemeProvider theme={styles}>
          <ApiServiceProvider>
            <IsMobile.Provider value={isMobile}>{children}</IsMobile.Provider>
          </ApiServiceProvider>
        </ThemeProvider>
      </IntlProvider>
    </Provider>
  );
};

export default Providers;
